var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:switch-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.332 2.5L16.6654 5.83333M16.6654 5.83333L13.332 9.16667M16.6654 5.83333H8.33203M6.66536 10.8333L3.33203 14.1667M3.33203 14.1667L6.66536 17.5M3.33203 14.1667H10.832",
    stroke: "#009EF8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwap);
export default __webpack_public_path__ + "static/media/icon-swap.82387ba2b44d35aac70ec6a4c9b2b481.svg";
export { ForwardRef as ReactComponent };